import {
  getDefaultStatisticItem,
  getTeamLabelByNumber
} from '../../utils/utils'

let previousActiveSide = null
let previousPlayTime = null
let isPeriodActive = false
let lastPenaltyKicks = 0
let lastPossession = 0
let goalsInARow = {
  home: 0,
  away: 0,
  lastGoalTeam: 0
}

export default {
  statisticScheme: {
    '2_MIN_PENALTY': getDefaultStatisticItem(),
    'PENALTY_THROW': getDefaultStatisticItem(),
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true }),
    'MAX_GOALS_IN_A_ROW': getDefaultStatisticItem('statistic.goalMax', { maxValueInSumStatistic: true }),
    'SUCCESSFUL_7_M_KICKS': getDefaultStatisticItem('statistic.7mKicks', { percentFromTotal: true }),
    'SUCCESSFUL_ATTACKS': getDefaultStatisticItem('statistic.attack', { percentFromTotal: true }),
    'GOAL_WHEN_MAX': getDefaultStatisticItem('statistic.goalWhenMax'),
    'GOAL_WHEN_MIN': getDefaultStatisticItem('statistic.goalWhenMin')
  },
  statisticEvents: {
    '2_MIN_PENALTY': '2_MIN_PENALTY',
    'PENALTY_THROW': 'PENALTY_THROW'
  },
  statisticOrder: [
    '2_MIN_PENALTY',
    'PENALTY_THROW',
    'possession',
    'MAX_GOALS_IN_A_ROW',
    'SUCCESSFUL_7_M_KICKS',
    'SUCCESSFUL_ATTACKS',
    'GOAL_WHEN_MAX',
    'GOAL_WHEN_MIN'
  ],
  statisticFunction (event) {
    const { EventCode } = event

    processPossessionStatistic.bind(this)(event)

    if (EventCode === 'HEARTBEAT') return

    processMaxGoalsInARow.bind(this)(event)
    processSuccessful7mKicks.bind(this)(event)
    processSuccessfulAttacks.bind(this)(event)
    processGoalsBasedOnPlayersCount.bind(this)(event)
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

function processSuccessfulAttacks (event) {
  const { EventCode, TeamNumber, GamePeriod } = event

  if (!GamePeriod) return

  switch (EventCode) {
    case 'POSESSION_1':
      if (lastPossession !== 1) {
        this.updateStatisticTotal({
          statisticType: 'defaultStatistic',
          property: 'SUCCESSFUL_ATTACKS',
          period: GamePeriod,
          team: getTeamLabelByNumber(TeamNumber),
          type: 'increment'
        })

        lastPossession = 1
      }

      break

    case 'POSESSION_2':
      if (lastPossession !== 2) {
        this.updateStatisticTotal({
          statisticType: 'defaultStatistic',
          property: 'SUCCESSFUL_ATTACKS',
          period: GamePeriod,
          team: getTeamLabelByNumber(TeamNumber),
          type: 'increment'
        })

        lastPossession = 2
      }

      break

    case 'GOAL':
      this.updateStatistic({
        statisticType: 'defaultStatistic',
        property: 'SUCCESSFUL_ATTACKS',
        period: GamePeriod,
        team: getTeamLabelByNumber(TeamNumber),
        type: 'increment'
      })
  }
}

function processSuccessful7mKicks (event) {
  const { EventCode, TeamNumber, GamePeriod } = event

  if (EventCode === 'PLAYER_READY') {
    return
  }

  if (EventCode === 'PENALTY_THROW') {
    this.updateStatisticTotal({
      statisticType: 'defaultStatistic',
      property: 'SUCCESSFUL_7_M_KICKS',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment'
    })

    lastPenaltyKicks = TeamNumber

    return
  }

  if (EventCode === 'GOAL' && lastPenaltyKicks === TeamNumber) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SUCCESSFUL_7_M_KICKS',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment'
    })

    lastPenaltyKicks = 0

    return
  }

  lastPenaltyKicks = 0
}

function processGoalsBasedOnPlayersCount (event) {
  const { EventCode, TeamNumber, GamePeriod } = event

  if (EventCode !== 'GOAL' || !GamePeriod) return

  const { getIngameData: { playersCount } } = this
  const { home, away } = playersCount
  const homeNumber = Number(home)
  const awayNumber = Number(away)

  if (homeNumber === awayNumber) return

  if (homeNumber > awayNumber && TeamNumber === 1) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'GOAL_WHEN_MAX',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment'
    })

    return
  }

  if (homeNumber > awayNumber && TeamNumber === 2) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'GOAL_WHEN_MIN',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment'
    })

    return
  }

  if (homeNumber < awayNumber && TeamNumber === 1) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'GOAL_WHEN_MIN',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment'
    })

    return
  }

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'GOAL_WHEN_MAX',
    period: GamePeriod,
    team: getTeamLabelByNumber(TeamNumber),
    type: 'increment'
  })
}

function processMaxGoalsInARow (event) {
  const { getMatchPeriods } = this
  const { TeamNumber, EventCode, GamePeriod } = event

  if (!GamePeriod) return

  const teamLabel = getTeamLabelByNumber(TeamNumber)
  const currentStatisticValue =
    getMatchPeriods[GamePeriod].statistic.defaultStatistic['MAX_GOALS_IN_A_ROW'][teamLabel]

  if (EventCode !== 'GOAL') return

  if (goalsInARow.lastGoalTeam === TeamNumber) {
    goalsInARow[teamLabel]++
  } else {
    goalsInARow = {
      ...{
        away: 0,
        home: 0,
        lastGoalTeam: TeamNumber
      },
      ...{
        [teamLabel]: 1
      }
    }
  }

  const newStatValue = goalsInARow[teamLabel]

  if (currentStatisticValue >= newStatValue) return

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'MAX_GOALS_IN_A_ROW',
    period: GamePeriod,
    team: teamLabel,
    value: newStatValue
  })
}

// function processPossession (event) {
//   const {
//     isTimerStoped,
//     getActiveSide,
//     getMatchPeriods,
//     getCurrentPeriod
//   } = this

//   const { EventCode, Playtime, GamePeriod } = event

//   if (!previousActiveSide && getActiveSide) {
//     previousActiveSide = getActiveSide
//   }

//   if (!isPeriodActive && EventCode !== 'START_PERIOD' && EventCode !== 'START_OVERTIME_PERIOD') return

//   if (!getCurrentPeriod || !previousActiveSide) return

//   const { overriddenType } = getMatchPeriods[getCurrentPeriod]

//   if (EventCode === 'START_PERIOD' || EventCode === 'START_OVERTIME_PERIOD') {
//     isPeriodActive = true
//   }

//   if (EventCode === 'FINISH_PERIOD' || EventCode === 'FINISH_OVERTIME_PERIOD') {
//     isPeriodActive = false
//   }

//   if (EventCode === 'START_PERIOD' || EventCode === 'START_OVERTIME_PERIOD' || overriddenType === 'shootout') {
//     previousPlayTime = Playtime

//     return
//   }

//   if (EventCode === 'STOP_GAME_CLOCK') {
//     this.updateStatistic({
//       statisticType: 'defaultStatistic',
//       property: 'possession',
//       period: GamePeriod || getCurrentPeriod,
//       team: previousActiveSide,
//       type: 'increment',
//       value: Playtime - previousPlayTime
//     })
//   }

//   if (isTimerStoped) {
//     previousPlayTime = Playtime

//     return
//   }

//   if (previousActiveSide !== getActiveSide) {
//     this.updateStatistic({
//       statisticType: 'defaultStatistic',
//       property: 'possession',
//       period: GamePeriod || getCurrentPeriod,
//       team: previousActiveSide,
//       type: 'increment',
//       value: Playtime - previousPlayTime
//     })

//     previousActiveSide = getActiveSide
//     previousPlayTime = Playtime

//     return
//   }

//   this.updateStatistic({
//     statisticType: 'defaultStatistic',
//     property: 'possession',
//     period: GamePeriod || getCurrentPeriod,
//     team: getActiveSide,
//     type: 'increment',
//     value: Playtime - previousPlayTime
//   })

//   previousPlayTime = Playtime
// }

function updateFunction ({ period, team, type, value }) {
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period,
    team,
    type,
    value
  })
}

function processPossessionStatistic (event) {
  const updateStatistic = updateFunction.bind(this)
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]

  if (!getActiveSide && !previousActiveSide) return

  if (EventCode === 'START_PERIOD' || overriddenType === 'shootout') {
    previousPlayTime = Playtime

    return
  }

  if (EventCode === 'STOP_GAME_CLOCK') {
    updateStatistic({
      type: 'increment',
      period: GamePeriod || getCurrentPeriod,
      team: previousActiveSide,
      value: Playtime - previousPlayTime
    })
  }

  if (isTimerStoped) {
    previousPlayTime = Playtime

    return
  }

  if (previousActiveSide !== getActiveSide) {
    if (previousActiveSide) {
      updateStatistic({
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    previousActiveSide = getActiveSide
    previousPlayTime = Playtime

    return
  }

  updateStatistic({
    period: GamePeriod || getCurrentPeriod,
    team: getActiveSide,
    type: 'increment',
    value: Playtime - previousPlayTime
  })

  previousPlayTime = Playtime
}